import Swiper from 'swiper';
import '@fancyapps/fancybox';

(function ($) {
  'use strict';

  $(document).ready(function () {
    var swiper = new Swiper('.featured-stories-slider', {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: '.client-next',
        prevEl: '.client-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 3,
        },
        1440: {
          spaceBetween: 40,
        },
      },
    });

    // Video popup using fancybox
    $('.section-featured-stories .play-icon').on('click', function () {
      const videoUrl = $(this).data('video-url');

      $.fancybox.open({
        src: videoUrl,
        type: 'video',
      });
    });
  });
})(jQuery);
